// betterprotein theme JS
// Cart logic is in header.liquid (bpOpenCart, attachCartForms)
// This file kept for any additional future JS
console.log('betterprotein theme loaded');
